import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Watchlist } from '../../monitoring.model';
import { MonitoringService } from '../../monitoring.service';


@Component({
  selector: 'app-watchlist-edit-create-dialog',
  standalone: true,
  imports: [
    CommonModule,
    DatePipe,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './watchlist-edit-create-dialog.component.html',
  styleUrls: ['./watchlist-edit-create-dialog.component.css']
})
export class WatchlistEditCreateDialogComponent implements OnInit {
  editForm: FormGroup;
  mode: 'create' | 'edit';
  watchlist: Watchlist | null = null;
  isSubmitting = false;
  serverError = '';
  watchlist_count: number = 0;
  constructor(
    public dialogRef: MatDialogRef<WatchlistEditCreateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private monitoringService: MonitoringService
  ) {
    this.serverError = '';
    this.mode = data?.mode || 'create';
    this.watchlist = data?.watchlist || null;
    this.watchlist_count = data?.watchlist_count || 0;
    this.editForm = this.fb.group({
      watchlist_name: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(255)]]
    });
  }

  ngOnInit(): void {
    if (this.mode === 'edit' && this.watchlist) {
      this.editForm.patchValue({
        watchlist_name: this.watchlist.watchlist_name
      });
    } else if (this.mode === 'create') {
      const defaultName = this.generateDefaultName();
      this.editForm.patchValue({
        watchlist_name: defaultName
      });
    }
  }

  private generateDefaultName(): string {
    return 'Watchlist ' + (this.watchlist_count + 1);
  }

  onSubmit(): void {
    if (this.editForm.valid && !this.isSubmitting) {
      this.isSubmitting = true;
      const formValue = this.editForm.value;
      
      // Validate name
      if (!formValue.watchlist_name?.trim()) {
        this.snackBar.open('Watchlist name is required', 'Close', { duration: 3000 });
        this.isSubmitting = false;
        return;
      }
      // if mode is create, create a new watchlist
      // Close dialog with result
     if(this.mode === 'create'){
      this.createWatchlist();
     }else{
      this.EditWatchlist();
     }
    }
  }
 
createWatchlist() {
  this.serverError = '';
  this.monitoringService.createWatchlist({ watchlist_name: this.editForm.value.watchlist_name.trim() }).subscribe(
    {
      next: (res) => {
      // this.router.navigate(['/monitoring']);
      // this.dialogRef.close(res);
      this.isSubmitting = false;
      this.snackBar.open('Watchlist created successfully', 'Close', { duration: 3000 });
      this.dialogRef.close(res);
    },
    error: (error: any) => {
      if(error.status === 400){
        this.serverError = 'Watchlist name already exists';
      }else{
        this.serverError = 'Error creating watchlist';
      }
      this.isSubmitting = false;
    }
  });
}

EditWatchlist() {
  this.serverError = '';
  this.monitoringService.updateWatchlist(this.watchlist!.watchlist_id, { watchlist_name: this.editForm.value.watchlist_name.trim() }).subscribe(
    {
      next: (res) => {
        this.isSubmitting = false;
        this.snackBar.open('Watchlist updated successfully', 'Close', { duration: 3000 });
        this.dialogRef.close(res);
      },
      error: (error) => {
        this.isSubmitting = false;
        if(error.status === 400){
          this.serverError = 'Watchlist name already exists';
        }else{
          this.serverError = 'Error updating watchlist';
        }
      }
    });
}


  onCancel(): void {
    this.dialogRef.close();
  }

  getTitle(): string {
    return this.mode === 'create' ? 'Create New Watchlist' : 'Edit Watchlist';
  }

  getSubmitButtonText(): string {
    return this.mode === 'create' ? 'Create Watchlist' : 'Save Changes';
  }

  getErrorMessage(fieldName: string): string {
    const field = this.editForm.get(fieldName);
    if (field?.hasError('required')) {
      return 'This field is required';
    }
    if (field?.hasError('minlength')) {
      return 'Name must be at least 1 character long';
    }
    if (field?.hasError('maxlength')) {
      return 'Name must be less than 255 characters';
    }
    return '';
  }
  // onWatchlistUpdated() {
  //   this.dialogRef.close();
  // }
}
